import { CowIcon } from './CowIcon';

/**
 * author: Austin Andrews
 * id 1D459B7E-A98C-4E02-929B-FA0BA329B97F
 * name cow
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cow.svg
 * tags
 * - Animal 
 * - Agriculture 
 */
export const EmoticonCowIcon = CowIcon;
export default EmoticonCowIcon